import { combineReducers } from 'redux-immutable'

import ui from './ui'
import data from './data'
import selectedNews from './selected_news'
import sorting from './sorting'
import cluster from './cluster'

export default combineReducers({
  ui,
  data,
  selectedNews,
  sorting,
  cluster
})
